import { render, staticRenderFns } from "./evidencia-profesiograma-ver.vue?vue&type=template&id=18796237&scoped=true&"
import script from "./evidencia-profesiograma-ver.vue?vue&type=script&lang=js&"
export * from "./evidencia-profesiograma-ver.vue?vue&type=script&lang=js&"
import style0 from "./evidencia-profesiograma-ver.vue?vue&type=style&index=0&id=18796237&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18796237",
  null
  
)

export default component.exports